import './jobs.scss';
import AjaxLoad from './../../components/ajax-load/ajax-load';
// import { JobsPagination } from './jobs-pagination';

class Jobs {
    constructor (element, options) {
        this.$jobs = element;

        const settings = {
            loader: null,
            onSubmitted: null,
            content: this.$jobs.querySelector('[data-jobs="content"]')
        };

        this.settings = Object.assign({}, settings, options);
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        const selects = this.$jobs.getElementsByTagName('select');
        for (let i = 0; i < selects.length; i++) {
            selects[i].addEventListener('change', () => {
                this.submitForm();
            });
        }
    }

    submitForm () {
        const $form = this.$jobs.querySelector('form');
        const formData = new FormData($form);

        if (this.settings.loader !== null) {
            const $loader = document.createElement('span');
            $loader.innerHTML = this.settings.loader;
            $form.appendChild($loader);
        }

        new AjaxLoad($form.action, { // eslint-disable-line
            requestMethod: $form.method,
            requestData: formData,
            onSuccess: (resultText) => {
                const $result = document.createElement('div');
                $result.innerHTML = resultText;
                this.settings.content.innerHTML = '';

                if ($result) {
                    this.settings.content.appendChild($result);
                }

                if (typeof this.settings.onSubmitted === 'function') {
                    this.settings.onSubmitted(this.$jobs);
                    this.setEvents();
                }
            }
        });
    }
}

export { Jobs };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $jobFilters = $context.querySelectorAll('[data-jobs="root"]');
        if ($jobFilters.length > 0) {
            for (let i = 0; i < $jobFilters.length; i++) {
                const jobs = new Jobs($jobFilters[i], {
                    onSubmitted: (result) => {
                        window.initContent(result);
                        // jobs.initialize();

                        const contentUpdateEvent = new CustomEvent('content.loaded', {
                            view: window,
                            bubbles: true,
                            cancelable: false,
                            detail: {
                                $context: result
                            }
                        });
                        window.dispatchEvent(contentUpdateEvent);
                    }
                });

                jobs.initialize();
            }
        }
    }
});
